import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import aboutHero from "../../assets/kaudulla-hero.jpg";
import img2 from "../../assets/kaudulla-safari.jpg";

function KaudullaNationalPark() {

    useEffect(() => {
        AOS.init({ duration: 900, once: true });
    }, []);

    return (
        <div className="w-full overflow-hidden">

            {/* ================= HERO SECTION ================= */}
            <section className="relative h-[40vh] w-full">
                <img
                    src={aboutHero}
                    alt="Habarana Beach"
                    className="absolute inset-0 w-full h-full object-fixed"
                />
                <div className="absolute inset-0 bg-black/60" />

                <div className="relative z-10 flex h-full flex-col items-center justify-center text-center text-white px-4">
                    <h1 data-aos="fade-up" className="text-4xl border border-[#c97b3a] bg-black/40 backdrop-blur-sm p-6 sm:p-5 sm:text-3xl md:text-4xl font-bold mb-3">
                        Kaudulla National Park
                    </h1>
                </div>
            </section>

            {/* ================= ABOUT SECTION ================= */}
            <section className="relative w-full py-20 bg-white">
                <div className="max-w-7xl mx-auto px-4">

                    {/* Image */}
                    <div
                        data-aos="zoom-in"
                        className="w-full overflow-hidden rounded-xl shadow-lg"
                    >
                        <img
                            src={img2}
                            alt="Habarana Bodhiya"
                            className="w-full h-[500px] object-fixed"
                        />
                    </div>

                    {/* Content Card */}
                    <div
                        data-aos="fade-up"
                        className="relative -mt-24 mx-auto max-w-4xl bg-white border border-[#c97b3a] p-8 md:p-12 shadow-xl"
                    >
                        <h2 className="text-3xl font-bold text-center mb-6">
                            Kaudulla National Park
                        </h2>

                        <p className="text-gray-700 leading-relaxed text-justify mb-4">
                            Kaudulla National Park is one of Sri Lanka’s premier wildlife sanctuaries,
                            located close to Habarana in the North Central Province. The park is famous
                            for large herds of wild elephants that gather around the Kaudulla Tank,
                            especially during the dry season.
                        </p>

                        <p className="text-gray-700 leading-relaxed text-justify mb-4">
                            The park features a diverse landscape of forests, grasslands, and wetlands,
                            supporting a wide range of wildlife including deer, wild boar, crocodiles,
                            and numerous species of birds. Its peaceful natural setting makes it ideal
                            for wildlife safaris and nature photography.
                        </p>

                        <p className="text-gray-700 leading-relaxed text-justify">
                            Today, Kaudulla National Park stands as an important conservation area,
                            offering visitors an unforgettable safari experience while protecting
                            Sri Lanka’s rich biodiversity and natural heritage.
                        </p>

                    </div>
                </div>
            </section>

            {/* ================= WHATSAPP FLOAT BUTTON ================= */}
            <a
                href="https://wa.me/94764806045?text=I%20saw%20your%20website.%20Can%20you%20give%20me%20information%20regarding%20your%20villa."
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-5 right-5 z-50"
            >
                <img
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/512px-WhatsApp.svg.png"
                    alt="WhatsApp"
                    className="h-12 w-12 sm:h-14 sm:w-14 rounded-full shadow-lg transition hover:scale-110"
                />
            </a>

        </div>
    );
}

export default KaudullaNationalPark;